import { useState } from 'react';
import { isBool } from '@/utils/types';

export function useToggle(initialValue = false) {
  const [value, setValue] = useState<boolean>(initialValue);

  const toggle = (bool?: boolean) => {
    if (isBool(bool)) setValue(bool);
    else setValue((val) => !val);
  };

  return [value, toggle] as const;
}
